module.exports = __webpack_public_path__ + "img/manageServices_d.d6d187d.svg";